<template>
  <div>
    <Header/>
    <MusicPlayer/>
    <Testimonials/>
    <News/>
  </div>
</template>

<script>
    import Header from './Header.vue'
    import MusicPlayer from './home/music_player/MusicPlayer.vue'
    import Testimonials from './home/Testimonials.vue'
    import News from './home/News.vue'

    export default {
        name: "Home",
        components: {
            Header,
            MusicPlayer,
            Testimonials,
            News,
        },
        mounted() {
            window.document.title = 'Corul Naţional de Cameră „Madrigal – Marin Constantin”'
        },
    }
</script>

<style scoped>
</style>
